import mount from "@/components/observe/mount"
import mqtt from "./mqtt"
import uav from "./uav"

export default () => ({
    mount,
    mqtt: mqtt(),
    uav: uav()
})